export default __webpack_public_path__ + "static/media/GM_Cup_Ancient.3163aa21.png";